import { getQueryStringParameter } from 'owa-querystring';

export function getInitialFoldersCount() {
    const foldersCount: string | undefined = getQueryStringParameter('initialfolders');
    return foldersCount;
}
